import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';
import { captureUtm } from '@/lib/utm';

/**
 * Fires a GA4/GTM page_view on every client-side route change.
 * Mount once at the App root.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Persist utm_* / gclid for the session (e.g. utm_source=chatgpt.com)
    captureUtm();
    // Defer to next tick so document.title (set by Helmet) is up to date.
    const id = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);
}
